module.exports = __webpack_public_path__ + "static/media/IMG-9.07205ee1.jpg";